import React from 'react';
import {   InfoBox,   ExerciseBox,   CodeBlock,   InlineCode,   SectionTitle,  Note, Image,  TableContainer,  Highlight,  PatternContainer,  SectionHeading,  SubHeading,  TwoColGrid,  ThreeColGrid,  GridItem,  Divider} from '../../../../components/course/CourseComponents';
import screen1 from '../screen1.jpg';

const IntroductionContent = () => {
  return (
    <>
       <InfoBox title="Introduction" color="blue">
        <p className="mb-0">
        Dans ce troisième jeu, nous allons apprendre à importer des assets, tels que des images et des sons, puis à les utiliser pour enrichir notre projet.<br/>
        Pour cela, nous allons recréer le célèbre jeu Flappy Bird.
        </p>
      </InfoBox>    

      <SectionTitle>🧠 Objectif du jeu</SectionTitle>
      
     

     

      <div className="flex flex-col md:flex-row gap-6 items-start mb-6">
        <div className="flex-1">
      
        <p className="mb-4">
        Le but du jeu Flappy Bird est de faire voler un oiseau en cliquant pour le faire sauter, tout en évitant les tuyaux.<br/>
        À chaque fois que l'oiseau passe entre deux tuyaux sans les toucher, le joueur marque un point. Le jeu se termine si l'oiseau percute un tuyau.</p>
        <p>Voici les notions que nous allons aborder :</p>
          <ul className="list-disc list-inside mb-4">
            <li>Chargement et affichage d'images pour le fond, l'oiseau et les tuyaux.</li>
            <li>Création et modification d'une liste pour afficher plusieurs tuyaux.</li>
            <li>Gestion de la gravité et du saut de l'oiseau.</li>
            <li>Gestion des collisions entre l'oiseau et les tuyaux.</li>
            <li>Lecture de sons pour les effets sonores.</li>
          </ul>
        </div>
        <div className="flex justify-center items-center">
          <Image 
            src={screen1} 
            alt="Aperçu du jeu de visée" 
            width="350px"
            height="350px"
            borderRadius="xl"
            shadow={true}
            border={false}
            className="object-contain"
          />
        </div>
      </div>

      <Note type="tip" title="Technologie utilisée :">
        Nous utiliserons JavaScript et la bibliothèque p5.js, qui fournit toutes les fonctions nécessaires à la création de jeux vidéo : interface simple pour gérer le rendu graphique, gérer les événements utilisateur et l'interaction en temps réel.
      </Note>

      <p>
      🎯 Prêt à coder ? C'est parti !
      </p>
     
     
    </>
  );
};

export default IntroductionContent; 